module.exports = __webpack_public_path__ + "static/media/theoryQ3.082b2c72.mp4";